import { motion } from "framer-motion-3d"
import { useContext } from "react"

import { buildings } from "../../../helpers/constants"
import AppContext from "../../../hooks/AppConext"
import { useColor } from "../../../hooks/useColor"
import { StateWrapper } from "../StateWrapper"

export const Building = ({ matcaps, name, nodes, ...props }) => {
  const matcap = matcaps[0]

  const { color } = useColor(name)
  const { geometry, position = [0, 0, 0] } = buildings[name]

  const { hovered, selected, menuHovered } = useContext(AppContext)
  const condition = [hovered, menuHovered, selected].includes(name)

  return (
    <StateWrapper name={name}>
      <mesh
        name={name}
        geometry={nodes[geometry].geometry}
        position={position}
        {...props}
        visible={condition}
      >
        <motion.meshMatcapMaterial
          animate={{
            opacity: Number(condition),
          }}
          transparent
          matcap={matcap}
          flatShading
          color={color}
          toneMapped={false}
        />
      </mesh>
    </StateWrapper>
  )
}
